import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useGetMe } from "hooks/auth";
import { ROLES_ENUM } from "enums";
import { CompaniesTabsType, ModalManage } from "../types";

export const useInvestmentsState = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const linkPage = searchParams.get("page");
  const { data: authorizedUser } = useGetMe();

  const [modalManage, setModalManage] = useState<ModalManage>({
    type: "",
    company: null,
  });

  const [page, setPage] = useState(Number(linkPage) || 1);
  const [tab, setTab] = useState<CompaniesTabsType["tab"]>(
    authorizedUser?.role === ROLES_ENUM.USER ? "my" : "reliance",
  );

  const [selectedSlug, setSelectedSlug] = useState<string | null>(null);

  const isAdmin = authorizedUser?.role === ROLES_ENUM.ADMIN;
  const isCompanyInfoOpenModal = modalManage.type === "details" && isAdmin;

  const setAddAsset = (slug: string) => {
    setSelectedSlug(slug);
    setModalManage({ type: "addAsset", company: null });
  };

  const closeAddAssetModal = () => {
    setSelectedSlug(null);
    setModalManage({ type: "", company: null });
  };

  const handleChangeTab = (item: CompaniesTabsType["tab"]) => {
    setTab(item);
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set("page", "1");
    newSearchParams.set("tab", item);
    setSearchParams(newSearchParams);
  };

  return {
    modalManage,
    setModalManage,
    page,
    setPage,
    tab,
    isAdmin,
    isCompanyInfoOpenModal,
    authorizedUser,
    selectedSlug,
    setAddAsset,
    closeAddAssetModal,
    handleChangeTab,
  };
};
